import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { ListPayload } from '@product/shared/models/ListPayload';
import { UserInvitationDto } from '../models/user-invitation-dto';
import { UserRegisterationDto } from '../models/user-registeration-dto';

@Injectable()
export class UsersService {
  url = '';
  constructor(private http: HttpClient) {
    this.url = AppConfigService.settings.apiUrl + 'Users/';
  }
  getUsers() {
    return this.http.get(this.url);
  }
  getUsersList(payload: ListPayload) {
    return this.http.post(this.url + 'list', payload);
  }
  getUser(id: string) {
    return this.http.get(this.url + id);
  }
  getUserByEmail(email: string) {
    return this.http.get(this.url + 'by-email/' + email);
  }
  inviteUser(user: UserInvitationDto) {
    return this.http.post(this.url, user);
  }
  registerUser(user: UserRegisterationDto) {
    return this.http.post(this.url + 'register', user);
  }
  getRoles() {
    return this.http.get(this.url + 'roles');
  }
  updateUser(user: any) {
    return this.http.put(this.url, user);
  }
  activateUser(email: string) {
    return this.http.put(this.url + 'activate-user', {
      username: email,
    });
  }
  deactivateUser(email: string) {
    return this.http.put(this.url + 'deactivate-user', {
      username: email,
    });
  }
}
